"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _DayPicker = _interopRequireDefault(require("../DayPicker"));

var _ = require("./..");

var _Form = require("../Form");

var _hooks = require("../../hooks");

var DayPickerField = function DayPickerField(props) {
  var _useClassNames = (0, _hooks.useClassNames)(props),
      classNames = _useClassNames.classNames,
      className = _useClassNames.className,
      restProps = (0, _objectWithoutPropertiesLoose2.default)(_useClassNames, ["classNames", "className"]);

  return /*#__PURE__*/_react.default.createElement(_.FieldWrapper, (0, _extends2.default)({
    alias: "DayPickerField",
    className: className,
    Field: _DayPicker.default
  }, restProps));
};

DayPickerField.propTypes = (0, _extends2.default)({
  /** It describes a standalone entity that is meaningful on its own. It will be used to generate the component className. */
  alias: _propTypes.default.string,

  /** It extends component styles. */
  className: _propTypes.default.string
}, _.FieldWrapper.propTypes);
DayPickerField.defaultProps = {
  alias: 'DayPickerField',
  className: ''
};
DayPickerField.displayName = 'DayPickerField';

var _default = (0, _Form.formalizer)(DayPickerField);

exports.default = _default;